import React from 'react';
import { Phone } from 'lucide-react';

const ContactSection = () => {
  return (
    <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          We're here for you 24/7!
        </h2>
        <p className="text-xl text-white mb-6">
          Give us a call anytime
        </p>
        <a
          href="tel:+917998666660"
          className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300 shadow-lg hover:shadow-xl"
        >
          <Phone className="w-6 h-6" />
          +91-79986-66660
        </a>
      </div>
    </div>
  );
};

export default ContactSection;